import { render, staticRenderFns } from "./ChooseTemplatesModal.vue?vue&type=template&id=12e5fc22&scoped=true"
import script from "./ChooseTemplatesModal.vue?vue&type=script&lang=js"
export * from "./ChooseTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e5fc22",
  null
  
)

export default component.exports